<template>
  <div id="campaign-result">
    <call />
    <pop-alert />
    <header>
      <top-bar title="抽選会" backUrl="/campaign/list"/>
      <span><menu-app></menu-app></span>
      <div class="ssm-overlay ssm-toggle-nav"></div>
    </header>
    <!-- main -->
    <main>
      <section :class="{ 'fade-base': true, 'fade': pageFade }" class="c-campaign-result">

         <!-- あたり -->
        <template v-if="lotteryResult == 1">
          <div class="c-campaign-result__inner hit" >
            <div class="title"><img class="kurukuru is-animated" src="/assets/images/campaign/hit-text.svg" alt="当たり"></div>

              <template v-if="lotteryCoupon && lotteryCoupon.length > 0">
                <div class="swiper-container js-swiper_coupon_body">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide view-result__coupon" v-for="coupon in lotteryCoupon" :key="coupon.id">
                      <div class="view-result__coupon-title">{{ coupon.title }}</div>
                      <viewImage
                        type="coupon"
                        :img="coupon.image"
                      />
                    </div>
                  </div>
                </div>

                <div class="swiper-pagination-m" v-if="lotteryCoupon && lotteryCoupon.length > 1"></div>
              </template>

          </div>
          <div class="c-campaign-result__button">
            <router-link to="/coupons?category=LotteryCoupon" replace class="bg-purple center-all-item btn-to-site decoration-none mb-8">クーポン一覧へ</router-link>
          </div>        
        </template >
         <!-- はずれ -->
        <template v-else-if="lotteryResult == 2">
          <div class="c-campaign-result__inner miss" >
            <div class="title"><img src="/assets/images/campaign/miss-text.svg" alt="はずれ"></div>
            <div class="image"><img src="/assets/images/campaign/miss-img.svg" alt=""></div>
            <div class="message"><img src="/assets/images/campaign/miss-text2.svg" alt="残念！はずれました。。。"></div>
            <p class="text">またのご参加<br>お待ちしております。</p>
          </div>
          <div class="c-campaign-result__button">
            <router-link to="/campaign/list" replace class="btn-outline center-all-item btn-to-site mb-8 decoration-none">一覧へ戻る</router-link>
          </div>        
        </template>
        <template v-else>
          <div class="c-campaign-result__inner miss" >
            <div class="mt-16">
              <div class="image"><img src="/assets/images/icon/icon-warning.svg" width="80px"></div>
              <div  class="text">抽選に失敗しました</div>
              <p class="text">お手数ですが、通信環境に良いところでもう一度ご応募ください。</p>
            </div>
          </div>
          <div class="c-campaign-result__button">
            <router-link to="/campaign/list" replace class="btn-outline center-all-item btn-to-site mb-8 decoration-none color-white">一覧へ戻る</router-link>
          </div>        
        </template>
      </section>
    </main>
    <transition name="fade" mode="out-in">
      <CampaignAnimation v-show="isLottery" @add="addProduct" :stopDisabled="stopDisabled" />
    </transition>

  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Menu from "../components/Menu.vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import { getCampaignDetail, getListCampaignCoupon, getUser, getServerListCoupon, getServerCampaignList } from "../store/firestore.js";
import PopAlert from "../components/PopAlert.vue";
import CampaignAnimation from "../components/CampaignAnimation.vue"
import viewImage from "../components/parts/viewImage.vue"
//import expirationDate from "../components/parts/expirationDate.vue"
import Swiper from "swiper";
import { Pagination } from "swiper";
import TopBar from "../components/TopBar.vue";

Swiper.use(Pagination);

export default Vue.extend({
  name: "CampaignResult",
  components: {
    'top-bar': TopBar,
    'menu-app': Menu,
    PopAlert,
    CampaignAnimation,
    viewImage,
    //expirationDate
  },
  mixins: [Tenant],
  data() {
    return {
      lotteryResult: 0,
      lotteryCoupon: [],
      isLottery: true,
      stopDisabled: true,
      campaign: {},
      campaignId: this.$route.params.id,
    }
  },
  async created() {

    this.campaign = await getCampaignDetail(this.campaignId);
    if (!this.campaign || !this.$route.query.obj) {
      this.$router.replace('/campaign/list');
    }
    this.couponsList = await getListCampaignCoupon(this.campaignId);
    const userId = this.$store.state.userId;

    /*
    const userData = await getUser(userId);
    const callable = firebase.functions('asia-northeast1').httpsCallable('lottery');
    const request = {
      "lotteryId": this.campaignId,
      "userId": userId,
      "lineFootPrint": userData.lineFootPrint
    };
    const result = await callable(request)
      .catch(async e => {
        // TODO エラー
        //this.loading = false;
        //await this.alert("エラーが発生しました。" + (e?.message||""), true);
        throw e;
      });
      */

    const result = JSON.parse(this.$route.query.obj)
    if (result.data.status == 'SUCCEED') {
      this.lotteryResult = result.data.lotteryResult;
      if (this.lotteryResult == 1) {
        var lotteryCouponIds = [result.data.lotteryCouponId1, result.data.lotteryCouponId2, result.data.lotteryCouponId3, result.data.lotteryCouponId4, result.data.lotteryCouponId5];
        lotteryCouponIds = lotteryCouponIds.filter(v => v && v != "")

        for (const lotteryCouponId of lotteryCouponIds) {
          const coupons = this.couponsList.filter(item => item.id == lotteryCouponId);
          if (coupons.length) {
            this.lotteryCoupon.push(coupons[0]);
          }
        }

        console.log("lotteryCoupon", this.lotteryCoupon.length)
        console.log(this.lotteryCoupon)

        // キャッシュ作成のため、呼び出し
        getServerListCoupon(userId);

      }
      this.stopDisabled = false;
    }
    // キャッシュ作成のため、呼び出し
    getServerCampaignList();
  },
  mounted() {
    Common.initDom();
  },
  watch: {
    lotteryResult: function (value) {
      console.log("lotteryResult", value)
      if (value == 1) {
        this.$nextTick(function () {
          new Swiper('.js-swiper_coupon_body', {
            slidesPerView: 1,
            //observer: true,
            pagination: {
              el: '.swiper-pagination-m',
              type: 'bullets',
              clickable: true,
            }
          })
        })
      }
    },
  },
  updated() {
    this.$nextTick(function () {
      Common.setKeepRatio()
    })
  },
  methods: {
    addProduct() {
      this.isLottery = false
      //this.result = "1"
    }
  }
})
</script>
